import { Pagination } from 'types'

export const ROLE_INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 15,
  sort: {
    by: 'name',
    order: 'ASC',
  },
}
